import { render, staticRenderFns } from "./OpenNumbers.vue?vue&type=template&id=5c17f078&scoped=true&"
import script from "./OpenNumbers.vue?vue&type=script&lang=ts&"
export * from "./OpenNumbers.vue?vue&type=script&lang=ts&"
import style0 from "./OpenNumbers.vue?vue&type=style&index=0&id=5c17f078&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c17f078",
  null
  
)

export default component.exports